var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAstersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1324_46695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1487 34.1243C35.993 34.8928 37.554 36.2059 38.6194 37.8851L46.0739 33.2435C43.9526 29.9007 40.8039 27.3228 37.0926 25.8901C35.8628 26.8421 34.9338 28.1236 34.4156 29.5829C33.8975 31.0422 33.8117 32.6182 34.1687 34.1243H34.1487Z",
    fill: "#FFB700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8858 45.5748L20.6076 44.3773C20.4331 43.0926 20.5198 41.7861 20.8625 40.5351C21.2053 39.284 21.7973 38.1138 22.6034 37.0933C21.6913 33.4683 21.8227 29.6624 22.9827 26.1078C19.2503 27.7147 16.1478 30.4845 14.1453 33.9973C12.1429 37.5102 11.3497 41.5747 11.8858 45.5748Z",
    fill: "#FFB700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3976 1.42505L25.6758 2.63246C25.8532 3.91729 25.7679 5.22441 25.425 6.47585C25.0821 7.72729 24.4887 8.89745 23.68 9.91654C24.5873 13.542 24.456 17.3466 23.3008 20.902C27.036 19.296 30.1408 16.5249 32.1436 13.0096C34.1464 9.49437 34.9378 5.42696 34.3976 1.42505Z",
    fill: "#F25178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1947 12.8857C10.3511 12.1209 8.79003 10.8111 7.72404 9.13477L0.219727 13.7764C2.33832 17.1192 5.48819 19.6947 9.20097 21.1198C10.4307 20.1679 11.3597 18.8864 11.8779 17.4271C12.3961 15.9678 12.4818 14.3918 12.1249 12.8857H12.1947Z",
    fill: "#F25178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9157 47L36.2345 40.0723C34.448 38.7299 33.1795 36.8208 32.6404 34.6633C32.1013 32.5057 32.3243 30.2301 33.2721 28.2158C34.2199 26.2015 35.8353 24.5703 37.8489 23.5942C39.8626 22.6181 42.1528 22.3561 44.3376 22.8518L46.3334 14.3405C42.196 13.4226 37.8666 13.9331 34.0615 15.7877C30.2565 17.6423 27.204 20.7297 25.4092 24.5391C23.6143 28.3485 23.1848 32.6514 24.1915 36.7359C25.1983 40.8203 27.5811 44.4415 30.9456 47H30.9157Z",
    fill: "#45D9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96653 24.1977L-0.0292969 32.709C4.11833 33.6412 8.4628 33.1365 12.2809 31.2789C16.0991 29.4214 19.1605 26.323 20.9558 22.4995C22.7511 18.676 23.1718 14.358 22.148 10.2644C21.1241 6.17069 18.7175 2.54825 15.3286 0L10.0197 6.92777C11.8082 8.2679 13.0793 10.1756 13.6212 12.3327C14.163 14.4899 13.9428 16.766 12.9972 18.7816C12.0517 20.7972 10.438 22.4304 8.42518 23.4088C6.41239 24.3872 4.12221 24.6517 1.9366 24.1581L1.96653 24.1977Z",
    fill: "#3FE8AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1324_46695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 47,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstersIcon);
export default __webpack_public_path__ + "static/media/asters-icon.92202681.svg";
export { ForwardRef as ReactComponent };